import useSWR from 'swr';
import api from '../../config/configApi';

const getToken = () => localStorage.getItem('token'); // ajuste a chave se for outra

const fetcher = async (url) => {
  try {
    const { data } = await api.get(url);

    if (data?.erro) {
      throw new Error(data?.mensagem || 'Erro na API');
    }

    return data?.indicacoes ?? [];
  } catch (err) {
    console.error('Erro ao buscar indicacoes:', err?.response?.status, err?.message);
    return [];
  }
};

export default function useindicacoesConfiguracoes() {
  const {
    data: indicacoes = [], error, isLoading, mutate,
  } = useSWR(
    '/indicacao/config/indicacoes',
    fetcher,
  );

  const criarIndicacao = async (payload) => {
    try {
      const token = getToken();
      await api.post('/indicacao/config/indicacoes', payload, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      await mutate();
    } catch (err) {
      const status = err?.response?.status;
      if (status === 403) {
        throw new Error('Sem permissão para criar indicação.');
      }
      throw err;
    }
  };

  const editarIndicacao = async (id, payload) => {
    try {
      await api.put(`/indicacao/config/indicacoes/${id}`, payload);
      await mutate();
    } catch (err) {
      const status = err?.response?.status;
      if (status === 403) {
        throw new Error('Sem permissão para editar indicação.');
      }
      throw err;
    }
  };

  return {
    indicacoes,
    isLoading,
    isError: !!error,
    criarIndicacao,
    editarIndicacao,
    refetch: mutate,
  };
}
